import { motion } from 'framer-motion';

export const ChapterMarker = ({ num, title, light = false }) => (
  <motion.div
    initial={{ opacity: 0, x: -24 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.7 }}
    className="flex items-center gap-4 mb-8 md:mb-12"
  >
    <span className="font-accent text-[10px] md:text-xs text-[#8C5A35]">CH. {num}</span>
    <span className="h-px w-12 md:w-20 bg-[#B89B72]/40" />
    <span className={`font-accent text-[10px] md:text-xs ${light ? 'text-[#F5F5F0]/60' : 'text-[#A3A3A3]'}`}>{title}</span>
  </motion.div>
);

export const RevealText = ({ children, className = '', delay = 0 }) => (
  <div className="overflow-hidden">
    <motion.div
      initial={{ y: '110%' }}
      whileInView={{ y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.9, delay, ease: [0.25, 1, 0.5, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  </div>
);
